import { env } from "./utils/environmentAccessor";

const featureFlagEnabled = (flagName: string) => {
  return (env[`VITE_FEATURE_FLAG_ENABLE_${flagName}`] as string) === "true";
};

export const redirectConfig = {
  loginUrl: env.VITE_LOGIN_REDIRECT_URL as string,
};

export const applicationConfig = {
  clientId: env.VITE_APPLICATION_CLIENT_ID as string,
  permissionScopes: (env.VITE_APPLICATION_PERMISSION_SCOPES as string).split(" "),
  language: env.VITE_APP_LANGUAGE as string,
  enabledDropdownLanguages: (env.VITE_ENABLED_DROPDOWN_LANGUAGES as string).split(",") as ("en" | "de" | "fr")[],
  featureFlags: {
    enableTermsOfUse: featureFlagEnabled("TERMS_OF_USE"),
    enableTranslationGlossary: featureFlagEnabled("TRANSLATION_GLOSSARY"),
    enableImageGeneration: featureFlagEnabled("IMAGE_GENERATION"),
    enableTranslationFeature: featureFlagEnabled("TRANSLATION_FEATURE"),
    enableWhiteLabel: featureFlagEnabled("WHITELABEL"),
    enableImageGenerationDisclaimer: featureFlagEnabled("IMAGE_GENERATION_DISCLAIMER"),
    enableTranscriptionSpeakerRecognition: featureFlagEnabled("TRANSCRIPTION_SPEAKER_RECOGNITION"),
  },
};

export const appInsightsConfig = {
  connectionString: (env.VITE_APPLICATION_INSIGHTS_CONNECTION_STRING as string | undefined) ?? "",
};

export const tenantConfig = {
  id: env.VITE_TENANT_ID as string,
};

const baseUrl = (env.VITE_API_BASEURL as string).replace(/\/+$/, "");
export const apiConfig = {
  baseUrl,
  url: `${baseUrl}/${env.VITE_API_SUFFIX as string}`,
};

export const customerName = env.VITE_CUSTOMER_NAME as "bmwet" | "bmb" | "bmluk";

export const appVersion = env.VITE_APP_VERSION as string;
